export default "__VITE_ASSET__OMKShjn0__"